var React = require('react');

function Signout (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"signout_icon","transform":"translate(-1 -3)"},[React.createElement("path",{"id":"Path_17876","data-name":"Path 17876","d":"M10.585,16.759l.749.741,4.152-4.1L11.34,9.29l-.749.741L12.5,11.971a3.713,3.713,0,0,0,1.163.814H1V14.01H13.642a3.714,3.714,0,0,0-1.139.784Z","transform":"translate(0 -2.398)","key":0}),React.createElement("path",{"id":"Path_17877","data-name":"Path 17877","d":"M9,3V6.692h1.238V4.231h9.9V17.769h-9.9V15.308H9V19H21.376V3Z","transform":"translate(-3.05)","key":1})]));
}

Signout.defaultProps = {"width":"17.326","height":"16","viewBox":"0 0 17.326 16"};

module.exports = Signout;

Signout.default = Signout;
